import { css } from "styled-components";
import { spacing8 } from "@churchofjesuschrist/eden-style-constants";
const shared = css(["margin:0;& ol,& ul{margin-block-end:", ";}"], spacing8);
export default shared;